import { render } from "./DemandReportTab.vue?vue&type=template&id=4ed0a6b8"
import script from "./DemandReportTab.vue?vue&type=script&lang=js"
export * from "./DemandReportTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__